var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-block chart"},[_c('h2',{staticClass:"dashboard-block__title"},[_vm._v("Traffic")]),_c('div',{staticClass:"dashboard-block__subtitle"},[_vm._v("Numbers of page views")]),_c('div',{staticClass:"line-chart"},[_c('canvas',{attrs:{"id":"lineCahrt"}})])])
}]

export { render, staticRenderFns }